import {
  AlertTriangle,
  ArrowDown,
  ArrowUp,
  ShieldAlert,
  TrendingUp,
} from "lucide-react";
import { ListSkeleton, SectionCard } from "@/shared/components";
import { cn } from "@/shared/lib/utils";
import { useAlerts } from "./hooks";
import { deriveSeverity } from "./utils";

const ALERT_STYLES = {
  critical: {
    bg: "bg-red-50",
    text: "text-red-700",
    icon: <ShieldAlert className="size-3.5" />,
  },
  warning: {
    bg: "bg-amber-50",
    text: "text-amber-700",
    icon: <AlertTriangle className="size-3.5" />,
  },
  info: {
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    icon: <TrendingUp className="size-3.5" />,
  },
};

export function RecentAlerts() {
  const { data: rankChanges, isLoading } = useAlerts(8);

  return (
    <SectionCard title="최근 알림">
      {isLoading ? (
        <ListSkeleton count={8} />
      ) : (
        <div className="space-y-2">
          {(rankChanges ?? []).map((rc, i) => {
            const severity = deriveSeverity(rc.change);
            const style = ALERT_STYLES[severity];
            return (
              <div
                key={`${rc.keyword}-${i}`}
                className={cn("rounded-sm px-3 py-2.5", style.bg, style.text)}
              >
                <div className="flex items-center gap-2">
                  {style.icon}
                  <span className="text-[12px] font-semibold">
                    {rc.keyword}
                  </span>
                  <span className="ml-auto text-[10px]">{rc.detectedAt}</span>
                </div>
                <p className="mt-1 flex items-center gap-1 text-[11px]">
                  {rc.previousRank}위 → {rc.currentRank}위
                  <span className="ml-1 inline-flex items-center gap-0.5 font-semibold">
                    {rc.change > 0 ? (
                      <ArrowDown className="size-3" />
                    ) : (
                      <ArrowUp className="size-3" />
                    )}
                    {Math.abs(rc.change)}단계
                  </span>
                </p>
              </div>
            );
          })}
          {(!rankChanges || rankChanges.length === 0) && (
            <p className="py-6 text-center text-[12px] text-text-tertiary">
              최근 감지된 순위 변동이 없습니다.
            </p>
          )}
        </div>
      )}
    </SectionCard>
  );
}
